var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReordered(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "24px",
    viewBox: "0 -960 960 960",
    width: "24px",
    fill: "#5f6368",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M160-490.23q0 78.69 53.27 133.54 53.27 54.84 131.19 56.23h45.39l-69.7-70.46 28.31-28.31L466.92-280 348.46-160l-28.31-28.31L390.31-260h-45.39q-94.23-1.38-159.57-68.31Q120-395.23 120-490q0-95.92 66.27-162.96T347.69-720h120v40h-120q-78.07 0-132.88 55.08Q160-569.85 160-490.23ZM563.08-260v-40H840v40H563.08Zm0-210v-40H840v40H563.08Zm0-210v-40H840v40H563.08Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReordered);
export default __webpack_public_path__ + "static/media/reordered.bb67f8e93d79ff910303c13ecd19dcea.svg";
export { ForwardRef as ReactComponent };